import moment from 'moment';
import { TrendData } from '../../../common/dashboards/models/TrendData';
import { DateUtils } from '../../../common/utils/DateUtils';
import { OrganizationSummary } from '../models/OrganizationSummary';

export class SummaryMapper {
  mapToDomain(organization: any): OrganizationSummary {
    const createdAt = organization.profiles?.edges?.[0]?.node?.createdAt;
    const trends = (organization.timeRepresentationSlices || []).map(
      (item: any) => new TrendData(DateUtils.toMoment(item.from), DateUtils.toMoment(item.to), item.high, item.medium, item.low, item.passed)
    );

    return new OrganizationSummary(organization.name, createdAt ? moment(createdAt) : null, trends);
  }
}
